module.exports = __webpack_public_path__ + "img/plus_circle.6d9fb05e.svg";